<!--
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-20 16:07:15
-->
<template>
  <div class="header-box">
    <div class="header">
      <div>
        <img src="@/assets/logo.png" class="logo" @click="goToHome" alt="">
        <!-- <a href="https://cloud.seatent.com/_index.html" class="logo">Logo</a> -->
      </div>
      <div class="option"
      v-if="$route.path!='/login'&&$route.path!='/register'&&$route.path!='/forgetPassword'">
        <!-- <a v-if="$store.state.isShowGoBack" @click="goToSuppot()">跳转管理后台</a> -->
        <a @click="logOut()">退出登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import environment from '@/untils/environment';
import { defineComponent, createVNode } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import remove from '@/untils/removeLocalStorage';

export default defineComponent({
  name: 'Home',
  components: {
  },
  // mounted() {
  // console.log(this.);
  // },
  methods: {
    goToAuthorize() {
      this.$router.push('/authorize');
    },
    logOut() {
      Modal.confirm({
        title: '确定退出登录?',
        icon: createVNode(ExclamationCircleOutlined),
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          remove();
          this.$router.push('/login');
        },
        onCancel() {
          console.log('Cancel');
        },
        class: 'test',
      });
    },
    goToHome() {
      window.open('https://cloud.seatent.com/_index.html');
    },
    async goToSuppot() {
      const accountId = await localStorage.getItem('accountId');
      const memberId = await localStorage.getItem('memberId');
      const token = await localStorage.getItem('token');
      const siteId = await localStorage.getItem('siteId');
      const store = this.$store;
      const loc = window.location;
      const uri = loc.host;
      const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go&isNew=${store.state.isNew}`;
      store.state.isNew = 0;
      console.log(url);
      window.location.href = url;
    },
  },
});
</script>
<style lang="stylus" scoped>
  .header-box
    width 100%
    position fixed
    top 0
    left 0
  .header
    width 1200px
    padding 15px 0
    margin 0 auto
    color #073D7D
    display flex
    justify-content space-between
    font-size 14px
    .logo
      float left
      margin-right 115px
      height 24px
      color #073D7D
      cursor pointer
    .header-list
      list-style none
      margin 0
      display flex
      li
        margin-right 60px
    .option
      a
        color #073D7D
        margin-left 27px
</style>
